import React from "react";
import Header from "components/Common/Header/Header";
import AppUserSurveyInviteBody from "components/AppUserComponents/AppUserDetails/AppUserSurveyInvites/AppUserSurveyInviteBody/AppUserSurveyInviteBody";

const AppUserSurveyInvites = () => {
  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="appuser" />

      <AppUserSurveyInviteBody />
    </main>
  );
};

export default AppUserSurveyInvites;
